import { StateService } from "@uirouter/angularjs";
import { BASE_OKR_VIEW_STATE } from "@gtmhub/okrs/okrs.states";

export const navigateToSingleOkrView = ($state: StateService, okrViewId: string): void => {
  $state.go(BASE_OKR_VIEW_STATE, { okrViewId });
};
